 import React from 'react';

const Header = ( props ) => {
    
    return (
        <div className="row header-alta-individuo modal-header">
        <div className="close" data-dismiss="modal" aria-hidden="true">
            <label className="ti-close clickable"></label>
            {/* onClick = { props.startClear }*/}
        </div>
        { /*<button buttonClass="btn btn-primary float-right" onClick={this.changeCliente}> Cambio cliente</button >*/}
            {!props.soloDatos&&<h2>Solicitud de Alta de Cuenta</h2>}
            {!props.soloDatos&&<h3>Verificacion de Datos del {props.titular ? "  Titular" :" Adicional/Extensión" } </h3>}
            {props.soloDatos&&<h2>Datos del Cliente</h2>}
                               
    </div>
        )
}

export default Header;